// src/pages/ServicePartnerListe.jsx
import { useEffect, useState } from "react";
import {
  Box,
  Heading,
  Flex,
  Text,
  VStack,
  HStack,
} from "@chakra-ui/react";
import axios from "axios";
import { IconButton } from "@chakra-ui/react";
import { Search, Pencil, Trash } from "lucide-react";

export default function ServicePartnerListe() {
  const [partner, setPartner] = useState([]);

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API_URL}/api/service-partner`)
      .then((res) => {
        const sorted = res.data.sort((a, b) =>
          a.firmenName.localeCompare(b.firmenName, "de", { sensitivity: "base" })
        );
        setPartner(sorted);
      })
      .catch((err) => console.error("Error loading Service Partner:", err));
  }, []);

  const handleDelete = async (id) => {
    if (window.confirm("Service Partner wirklich löschen?")) {
      await axios.delete(`${process.env.REACT_APP_API_URL}/api/service-partner/${id}`);
      setPartner((prev) => prev.filter((p) => p.id !== id));
    }
  };

  return (
    <Box maxW="4xl" mx="auto" mt={10} p={8} bg="white" borderRadius="xl" boxShadow="lg">
      <Heading size="md" mb={6}>
        Service Partner Liste
      </Heading>

      <VStack align="stretch" spacing={3}>
        {partner.map((p) => (
          <Flex
            key={p.id}
            justify="space-between"
            align="center"
            p={3}
            borderWidth="1px"
            borderRadius="md"
          >
            <Text fontWeight="semibold" color="blue.600">
              {p.firmenName} — {p.partnerName}
              <Text as="span" color="gray.600">
                {" "}
                ({p.ort})
              </Text>
            </Text>

            <HStack>
              <IconButton
                aria-label="View"
                colorPalette="blue"
                onClick={() => (window.location.href = `/service-partner/${p.id}`)}
              >
                <Search size={18} />
              </IconButton>

              <IconButton
                aria-label="Edit"
                colorPalette="green"
                onClick={() => (window.location.href = `/service-partner/edit/${p.id}`)}
              >
                <Pencil size={18} />
              </IconButton>

              <IconButton
                aria-label="Delete"
                colorPalette="red"
                onClick={() => handleDelete(p.id)}
              >
                <Trash size={18} />
              </IconButton>
            </HStack>
          </Flex>
        ))}
      </VStack>
    </Box>
  );
}